import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { Typography, type TypographyPropsBag } from '@repo/ui/Typography';
import { getOddsLabel } from '@/features/approval-odds/utils';
import type { ComponentDriver } from '@/features/product-card/types';
import { ApprovalOddsButton } from './ApprovalOddsButton';
import { TransUnionLink } from './TransUnionLink';
import type { ApprovalOddsAnalytics, Odds } from './types';
export type ApprovalOddsTextContentProps = {
  userCreditScore: number | undefined;
  odds: Odds;
  analytics?: ApprovalOddsAnalytics;
  isAmexOffer?: boolean;
  showBCCVariant?: boolean;
  hideOddsButton?: boolean;
  hideTooltip?: boolean;
  firePageActionOnClick?: boolean;
  typographyProps?: TypographyPropsBag;
};
export const ApprovalOddsTextContent = t0 => {
  const $ = _c(31);
  const {
    userCreditScore,
    odds,
    showBCCVariant,
    analytics,
    isAmexOffer,
    hideOddsButton,
    hideTooltip,
    firePageActionOnClick,
    typographyProps
  } = t0;
  let t1;
  if ($[0] !== odds.max || $[1] !== odds.min) {
    t1 = getOddsLabel(odds.min, odds.max);
    $[0] = odds.max;
    $[1] = odds.min;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const oddsLabel = t1;
  let label = showBCCVariant && userCreditScore ? `(${odds.min}-${odds.max})` : `(${oddsLabel})`;
  if (isAmexOffer) {
    label = !userCreditScore ? oddsLabel : `(${oddsLabel})`;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = css({
      position: "relative"
    });
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isAmexOffer || $[5] !== odds.max || $[6] !== odds.min || $[7] !== typographyProps?.css || $[8] !== userCreditScore) {
    t3 = !userCreditScore && !isAmexOffer && <Typography as="span" variant="text" css={{
      display: "inline",
      ...typographyProps?.css
    }}>{odds.min}-{odds.max}</Typography>;
    $[4] = isAmexOffer;
    $[5] = odds.max;
    $[6] = odds.min;
    $[7] = typographyProps?.css;
    $[8] = userCreditScore;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== showBCCVariant || $[11] !== typographyProps?.css || $[12] !== userCreditScore) {
    t4 = userCreditScore && <><Typography as="span" variant="text" css={{
        display: "inline",
        ...typographyProps?.css
      }}>{userCreditScore * 850}</Typography><TransUnionLink forceMobile={showBCCVariant} /></>;
    $[10] = showBCCVariant;
    $[11] = typographyProps?.css;
    $[12] = userCreditScore;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      ml: "1"
    };
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = typographyProps?.css;
  let t7;
  if ($[15] !== t6) {
    t7 = {
      display: "inline",
      "&:not(:first-child)": t5,
      ...t6
    };
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== label || $[18] !== t7) {
    t8 = <Typography as="span" variant="text" css={t7}>{label}</Typography>;
    $[17] = label;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== analytics || $[21] !== firePageActionOnClick || $[22] !== hideOddsButton || $[23] !== hideTooltip || $[24] !== userCreditScore) {
    t9 = !userCreditScore && !hideOddsButton && <ApprovalOddsButton analytics={analytics} hideTooltip={hideTooltip} firePageActionOnClick={firePageActionOnClick} />;
    $[20] = analytics;
    $[21] = firePageActionOnClick;
    $[22] = hideOddsButton;
    $[23] = hideTooltip;
    $[24] = userCreditScore;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t3 || $[27] !== t4 || $[28] !== t8 || $[29] !== t9) {
    t10 = <div className={t2}>{t3}{t4}{t8}{t9}</div>;
    $[26] = t3;
    $[27] = t4;
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
};
export const DefaultApprovalOddsTextContentTypographyProps: TypographyPropsBag = {
  css: css.raw({
    fontSize: {
      base: '[15px]',
      _pcMd: '1rem'
    },
    fontFamily: 'gothamDisplay',
    fontWeight: '[500]',
    lineHeight: '[140%]'
  })
};
export function getDefaultApprovalOddsTextContentDriver(props: Omit<ApprovalOddsTextContentProps, 'typographyProps'>): ComponentDriver {
  return {
    id: 'recommendedCreditScore',
    label: props.isAmexOffer ? 'Recommended credit' : 'Recommended credit score',
    value: <ApprovalOddsTextContent {...props} typographyProps={DefaultApprovalOddsTextContentTypographyProps} />
  };
}